import { gql } from '@apollo/client';

export const Client = {
  fragments: {
    main: gql`
      fragment Main on Client {
        civilite
        nom
        prenom
        adressefacturation
        cpfacturation
        villefacturation
        tel
        mail
        livraisonhorslycee
        civilitelivraison
        prenomlivraison
        nomlivraison
        adresselivraison
        cplivraison
        villelivraison
        mobilelivraison
        clientpro
        nomsociete
        policy
        affilie
        nompointrelais
      }
    `,
    clientResult: gql`
      fragment ClientResult on ClientResult {
        id
        civilite
        nom
        prenom
        adressefacturation
        cpfacturation
        villefacturation
        tel
        mail
        livraisonhorslycee
        civilitelivraison
        prenomlivraison
        nomlivraison
        adresselivraison
        cplivraison
        villelivraison
        mobilelivraison
        clientpro
        nomsociete
        policy
        affilie
        nompointrelais
      }
    `
  }
};
